import CIMSTable from 'components/CIMSTable'
import { useColumns } from './hooks/useColumns'
import { useEdit } from './hooks/useEdit'
import { useInternalConnectionsContext } from './InternalConnectionsContext'

const InternalConnections: React.FC = () => {
  const { data, refetch: onReload, fetching } = useInternalConnectionsContext()
  const columns = useColumns()
  const edit = useEdit()
  return (
    <CIMSTable
      rowKey="id"
      records={data}
      columns={columns}
      loading={fetching}
      actions={{ header: { onReload }, row: { edit } }}
    />
  )
}

export default InternalConnections
